import gql from "graphql-tag";

export const fragments = {
  searchResponse: gql`
    fragment searchResponse on SearchResponseCategory {
      i18nKey
      results {
        type
        key
        id
        title
        description
      }
    }`
};
